"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatBatchItemStatus_1 = __importDefault(require("./formatBatchItemStatus"));
const lodash_1 = __importDefault(require("lodash"));
const getItemDataId_1 = __importDefault(require("./getItemDataId"));
const getDisplayStatusKey_1 = __importDefault(require("./getDisplayStatusKey"));
function apiOrderToAppOrder(apiOrder) {
    var _a, _b, _c, _d, _e;
    const appOrder = Object.assign(Object.assign({}, apiOrder), { batches: (_a = apiOrder.batches) === null || _a === void 0 ? void 0 : _a.map(apiBatch => toAppBatch(apiBatch, apiOrder)), 
        // modifiers 為變價新格式，若後端還沒有，從將原本的 discount 格式轉換進來
        modifiers: (_b = apiOrder.modifiers) !== null && _b !== void 0 ? _b : [apiOrder.discount], 
        // payments 為付款新格式，若後端還沒有，從將原本的相關欄位轉換進來
        payments: (_d = (_c = apiOrder.payments) === null || _c === void 0 ? void 0 : _c.map(apiPayment => toAppPayment(apiPayment))) !== null && _d !== void 0 ? _d : [], subOrderIds: (_e = apiOrder.subOrderIds) !== null && _e !== void 0 ? _e : [], displayStatusKey: 'unknown' });
    appOrder.displayStatusKey = getDisplayStatusKey_1.default(appOrder);
    return appOrder;
}
exports.default = apiOrderToAppOrder;
function toAppPayment(apiPayment) {
    return Object.assign(Object.assign({}, apiPayment), { isSended: true });
}
function toAppBatch(apiBatch, apiOrder) {
    return Object.assign(Object.assign({}, apiBatch), { id: apiBatch.batchId, items: toAppBatchItems(apiBatch.items, apiOrder) });
}
function toAppBatchItems(apiBatchItems, apiOrder) {
    // group by set
    const setIndexGroups = lodash_1.default.groupBy(apiBatchItems, 'setMenuIndex');
    // setMenuIndex null 就是單點的項目
    const batchItems = [];
    if (setIndexGroups.null != null) {
        setIndexGroups.null.forEach(item => {
            try {
                const convertedSingleItems = toAppBatchItem(item, apiOrder);
                batchItems.push(...convertedSingleItems);
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    // 處理完單點項目後移除 null array
    delete setIndexGroups.null;
    // 處理套餐 group
    lodash_1.default.forEach(setIndexGroups, (setItems) => {
        // 餐點中的其中一個是套餐本身
        const mainSetItemIndex = setItems.findIndex(setItem => setItem.setId !== '');
        let mainSetItem;
        if (mainSetItemIndex >= 0) {
            // 移除套餐本身
            mainSetItem = setItems.splice(mainSetItemIndex, 1)[0];
            // 將套餐餐點放入 mainSetItem
            mainSetItem.setItems = setItems;
            mainSetItem.isSet = true;
            // 整理成 app 格式
            try {
                const convertedAppBatchItems = toAppBatchItem(mainSetItem, apiOrder);
                batchItems.push(...convertedAppBatchItems);
            }
            catch (error) {
                console.log(error);
            }
        }
    });
    return batchItems;
}
function toAppBatchItem(item, apiOrder) {
    var _a;
    const surchargeModifier = (_a = lodash_1.default.find(apiOrder === null || apiOrder === void 0 ? void 0 : apiOrder.modifiers, ['type', 'SURCHARGE'])) !== null && _a !== void 0 ? _a : { percent: 0, amount: 0 };
    const isSet = Boolean(item.isSet);
    /**
     * 後端給的 item 注意事項
     * item 會把相同 menuId 的品項都組在一起
     * item.ids 會有每個 batch item 各自的 id
     * item.options 會有每個 batch item 各自的 options
     * item.originalTotal 為原價 * quantity
     * item.price 為原價 - discount (單個的價錢)
     * item.prices 為原價 - discount (單個的價錢)
     * item.totalDiscount 為計算數量 modifiers 後的總折扣
     * item.total 已計算數量 discount 及 modifiers 但未計算服務費
     */
    const dataIdItemMap = {};
    item.ids.forEach((id, index) => {
        var _a, _b, _c, _d, _e;
        // 原價
        const price = item.price;
        // 單個餐點的價格(未算服務費)
        const totalWithoutSurcharge = item.totals[index];
        // menu item 折扣
        const discount = (_a = item.discounts[index]) !== null && _a !== void 0 ? _a : 0;
        // 折扣總計
        const totalDiscount = item.totalDiscounts[index];
        // 其他折扣
        const modifiers = (_b = item.modifiers[index]) !== null && _b !== void 0 ? _b : [];
        // 計算服務費
        const surcharge = totalWithoutSurcharge * surchargeModifier.percent / 100 + surchargeModifier.amount;
        // 預設不收服務費
        const itemSurcharge = item.excludedOrderSurcharge ? 0 : surcharge;
        const total = item.cancelled ? 0 : Number(totalWithoutSurcharge);
        const setItems = [];
        if (isSet && item.setItems != null) {
            item.setItems.map(setItem => {
                const convertedSetItems = toAppBatchItem(setItem, apiOrder);
                setItems.push(...convertedSetItems);
            });
        }
        const appBatchItem = Object.assign(Object.assign({}, item), { id: id, menuId: item.originMenuId, quantity: 1, totalDiscount,
            price,
            discount, surcharge: itemSurcharge, total, key: id, modifiers, options: toAppBatchItemOptions((_c = item.options[index]) !== null && _c !== void 0 ? _c : []), tags: toAppBatchItemTags((_d = item.tags[index]) !== null && _d !== void 0 ? _d : []), remarks: toAppBatchItemRemarks((_e = item.remarks[index]) !== null && _e !== void 0 ? _e : []), isSet: isSet, setItems: setItems, status: '' });
        if (isSet) {
            // set 的 discountTotal, surcharge, total 需連底下餐點一起加總顯示
            appBatchItem.totalDiscount += Number(lodash_1.default.sumBy(appBatchItem.setItems, 'totalDiscount'));
            appBatchItem.surcharge += Number(lodash_1.default.sumBy(appBatchItem.setItems, 'surcharge'));
            appBatchItem.total += Number(lodash_1.default.sumBy(appBatchItem.setItems, 'total'));
            // set 的 status 改顯示套餐底下的餐點名稱
            appBatchItem.status = appBatchItem.setItems.map(setItem => {
                if (setItem.status.length > 0) {
                    return `${setItem.name}(setItem.status)`;
                }
                return setItem.name;
            }).join('/');
        }
        // 讓相同的設定的 item 有相同的 dataId
        const dataId = getItemDataId_1.default(appBatchItem);
        const sameIdItem = dataIdItemMap[dataId];
        if (sameIdItem == null) {
            dataIdItemMap[dataId] = appBatchItem;
        }
        else {
            // 將這個 item 加入原有的 item
            sameIdItem.totalDiscount += appBatchItem.totalDiscount;
            sameIdItem.surcharge += appBatchItem.surcharge;
            sameIdItem.total += appBatchItem.total;
            sameIdItem.quantity += 1;
        }
    });
    const appBatchItems = lodash_1.default.map(dataIdItemMap, appBatchItem => {
        return formatBatchItemStatus_1.default(appBatchItem);
    });
    return appBatchItems;
}
function toAppBatchItemOptions(options = []) {
    const appOptions = options.map(option => {
        return Object.assign(Object.assign({}, option), { optionItemId: option.optionId });
    });
    return appOptions;
}
function toAppBatchItemTags(tags = []) {
    return tags;
}
function toAppBatchItemRemarks(remarks = []) {
    return remarks;
}
//# sourceMappingURL=apiOrderToAppOrder.js.map